module.exports = __webpack_public_path__ + "img/sav_cover.e258edcf.jpg";